"use strict";

(function (global) {
  var BUTTONS = {
    WITHOUT_AGENT: "work_without_agent_button"
  };

  // Интервал пинга агента.
  var PING_INTERVAL = 2000;

  var WaitAgentRunDialog = WA.CMP.dialogs.BaseDialog.extend({
    className: 'WaitAgentRunDialog',
    title: L("AGENT_SUCCESS_UPDATE_FAIL_RESTART_TITLE"),
    mainText: L("AGENT_RUN_WAITING_TEXT"),
    awaitingText: L("AGENT_RUN_WAITING"),
    completeAction: null,
    _agentStartTimerId: null,

    /**
    * Инициализация диалога.
    *
    * @method WebAccess.components.dialogs.WaitAgentRunDialog#init
    * @param {object} settings Настройки диалога
    */
    init: function (settings) {
      var me = this;
      me._super($.extend({}, settings, { isShowCancelButton: false, isShowOkButton: false }));

      me.bind(me['class'].EVENT.AFTER_CLOSE, function () {
        clearInterval(me._agentStartTimerId);
        me._agentStartTimerId = null;
      });
    },

    /**
    * Показать диалог.
    *
    * @method WebAccess.components.dialogs.WaitAgentRunDialog#show
    * @return WebAccess.components.dialogs.WaitAgentRunDialog
    */
    show: function () {
      var me = this;
      me._initButtons();
      me.removeCloseButton();
      
      me.setHtml(me._getHtml());

      me._super();
      me._initRunWaitHandling();

      // Навешиваем событие на иконку "?".
      BindHelpIcoClickOnModalWindow('RunWithAgentDialog', me._jDialog.parents('.ui-dialog'));
      //FIXME: нужно переверстать окно диалога, под кнопки заголовка нужно добавить отдельный контейтер с position:absolute и размещением справа,
      // кнопки уже размещать в самом контейнере с выравниванием направо и нужными мерджингами.
      me._jDialog.parents('.ui-dialog').find('.ui-dialog__help-button').attr('style', 'position: absolute; right: 10px; display: inline');
      return me;
    },

    /**
    * Работать без агента.
    *
    * @private
    */
    _disableAgent() {
      Core.agent.disable();      
    },

    /**
    * Инициализировать кнопки для диалога.
    *
    * @private
    */
    _initButtons() {
      var me = this;
      me.modalWindowButtons = [];
      me.modalWindowButtons.push({
        id: BUTTONS.WITHOUT_AGENT,
        text: L("CONTINUE_WITHOUT_AGENT"),
        click: function () {
          me._disableAgent();
        },
        class: 'primary',
      });      
    },

    /**
    * Возвращает html-разметку для окна.
    * @private
    */
    _getHtml() {
      var mainTextHtml = '<div class="upper-area">' + this.mainText + '</div>';
      var awaitingTextHtml = '<div class="lower-area float-dialog__loading_shown"><img src="/images/spinner.gif"><span class="float-dialog__loading-text">' + this.awaitingText + '</span></div>';
      //var additionalTextHtml = '<div class="lower-area">' + this.additionalText + '</div>';
      var html = '<div class="main-area">' + mainTextHtml + awaitingTextHtml + '</div>';
      return html;
    },

    // Инициализация ожидания запуска агента.
    _initRunWaitHandling() {
        // Таймер с проверкой запуска агента
      this._agentStartTimerId = setInterval(() => {                
        WA.agent.checkSessionState(1).done(() => {
          if (this._agentStartTimerId) {
            log.info('AGENT', 'Agent started.');
            this.close();
            if (this.completeAction) {
              this.completeAction();
            }
          }          
        });
      }, PING_INTERVAL);

      log.info('AGENT', 'Agent run awaiting...');
    },
  }, {
    EVENT: $.extend({
      // Событие срабатывает после старта агента.
      AFTER_START: 'start',
    }, WA.CMP.dialogs.BaseDialog.EVENT)
  });

  global.WaitAgentRunDialog = WaitAgentRunDialog;
})(window.Core.agent);
